import { Metamodel } from 'app/model/base/model';
import { AmazonS3WriteSettings } from './amazon-s3-store-write-settings';
import { AmazonS3CompatibleLinkedService } from 'app/model/linkedservice/amazon-s3-compatible.linkedservice';

@Metamodel.model({
    name: 'AmazonS3CompatibleWriteSettings',
    tags: {
        linkedServiceModel: Metamodel.modelFor(AmazonS3CompatibleLinkedService)
    }
})
export class AmazonS3CompatibleWriteSettings extends AmazonS3WriteSettings {
}
